import { environment } from '../../../../../environments/environment';

export const INTERNAL_PLWC_CREDIT_PLANS_ENDPOINT = `${environment.apiBaseUrl}/internal/plwc/credit-plans`;
export const INTERNAL_PLWC_CREDIT_PLAN_ENDPOINT = (creditPlanId: number) =>
  `${environment.apiBaseUrl}/internal/plwc/credit-plans/${creditPlanId}`;
export const INTERNAL_PLWC_CREDIT_PLAN_LOAN_TEMPLATES_ENDPOINT = `${environment.apiBaseUrl}/internal/plwc/credit-plans/loan-templates`;
